/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';
import {homepage} from "../../../config";

export default connectRequests((state) => ({
  localizations: {
    url: '/localizations?locale=' + state.localePicker,
    onLoad: true,
    onUpdate: true
  },
  defaultLocalizations: {
    url: '/localizations?locale=' + homepage.default_locale,
    onLoad: true,
    onUpdate: true
  },
  locales: {
    url: '/locales',
    onLoad: true,
  }
}));
